var exports = {
  "j": "xe30f6088--08d6d5--full-link",
  "A": "xe30f6088--08d6d5--full-link--redesign",
};

module.exports = exports;
